import { ypsilantiConfig } from "./data";
import CityPageTemplate from "../city-template/CityPageTemplate";

export default function YpsilantiPage() {
  return <CityPageTemplate config={ypsilantiConfig} />;
}